import styled from "styled-components";

export const SeparatorDefaultBox = styled.div`
    height: 38px;
    width: 2.5px;
    margin: 0 9px;
    background-repeat: no-repeat;
    background: ${props => `radial-gradient(closest-side at 50% 50%,${props.theme.colors.brandPrimary} 0%,${props.theme.colors.brandPrimary}70 85%,${props.theme.colors.brandPrimary}00 100%)`};
 `;
